export const getPushPull = (
  primaryRecord,
  currentProperty,
  initialProperty
) => {
  const current = primaryRecord[currentProperty]
  const old = primaryRecord[initialProperty]

  return getPushPullByLists(current, old)
}

export const getPushPullByLists = (currentList, initialList) => {
  const push = currentList
    .filter(
      oneCurrent => !initialList.some(oneOld => oneOld.id === oneCurrent.id)
    )
    .map(o => o.id)
  const pull = initialList
    .filter(oneOld => !currentList.some(oneNew => oneNew.id === oneOld.id))
    .map(o => o.id)

  return { push, pull }
}

export const getPartySkillsetAssociations = (currentList, initialList) => {
  const requiredFields = [
    'party_id',
    'skillset_id',
    'effective_at',
    'expires_at',
    'doc_url'
  ]

  const push = currentList.filter(
    oneCurrent =>
      !initialList.some(
        oneOld =>
          oneOld.party_id === oneCurrent.party_id &&
          oneOld.skillset_id === oneCurrent.skillset_id
      )
  )

  // incoming currentList contains all garbage properties that API give but not take, which need to be removed

  push.forEach(pushRecord => {
    const fieldsToDelete = []

    for (const prop in pushRecord) {
      if (!requiredFields.includes(prop)) {
        fieldsToDelete.push(prop)
      }
    }
    fieldsToDelete.forEach(f => {
      delete pushRecord[f]
    })

    pushRecord.deleted_at = null
  })

  const pull = initialList.filter(
    oneOld =>
      !currentList.some(
        oneNew =>
          oneNew.party_id === oneOld.party_id &&
          oneNew.skillset_id === oneOld.skillset_id
      )
  )
  pull.forEach(pullRecord => {
    const fieldsToDelete = []

    for (const prop in pullRecord) {
      if (!requiredFields.includes(prop)) {
        fieldsToDelete.push(prop)
      }
    }
    fieldsToDelete.forEach(f => {
      delete pullRecord[f]
    })

    pullRecord.deleted_at = new Date()
  })

  const updates = currentList.filter(oneCurrent =>
    initialList.some(
      oneOld =>
        oneOld.party_id === oneCurrent.party_id &&
        oneOld.skillset_id === oneCurrent.skillset_id
    )
  )

  updates.forEach(updateRecord => {
    const fieldsToDelete = []

    for (const prop in updateRecord) {
      if (!requiredFields.includes(prop)) {
        fieldsToDelete.push(prop)
      }
    }
    fieldsToDelete.forEach(f => {
      delete updateRecord[f]
    })

    updateRecord.deleted_at = null
  })

  const returnValue = push.concat(pull).concat(updates)
  //console.log('B4 Update Skillsets', returnValue)
  return returnValue
}
